import { Monitor, Moon, Sun } from "lucide-react";

import { THEME_MODES, useThemeMode } from "@/themes";

const ICONS = { light: Sun, dark: Moon, auto: Monitor };

// Apparence enregistrée sur le compte : retrouvée sur tous les appareils
export const ThemeModePicker = () => {
  const { mode, setMode } = useThemeMode();
  return (
    <div className="crm-theme-pick" data-testid="theme-mode-picker">
      <p className="eyebrow">APPARENCE</p>
      <div className="seg crm-seg-row" role="group" aria-label="Thème">
        {THEME_MODES.map(({ id, label }) => {
          const Icon = ICONS[id];
          return (
            <button key={id} type="button" className="seg__btn" aria-pressed={mode === id} onClick={() => setMode(id)} data-testid={`theme-mode-${id}`}>
              <Icon size={13} /> {label}
            </button>
          );
        })}
      </div>
      <p className="crm-settings__sub">{mode === "auto" ? "Suit le réglage clair/sombre de votre appareil." : "Enregistré sur votre compte."}</p>
    </div>
  );
};
